import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import _ from 'lodash';
import mergeStates from '../../helpers/mergeStates';

const countries = require('i18n-iso-countries');

const countriesArray = countries.getNames('de');

const countriesOptions = [];
_.forOwn(countriesArray, (label, value) => {
  // create new object that will be handled by griddle
  countriesOptions.push({
    value,
    label,
  });
});

class FormAddress extends React.Component {
  constructor(props) {
    super(props);
    if (typeof props.value !== 'undefined' && props.value !== null) {
      const ministate = {};

      _.forOwn(props.value, (value, key) => {
        ministate[key] = value === null ? '' : value;
      });

      this.state = ministate;
    } else {
      this.state = {
        country: '',
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== null && typeof nextProps.value !== 'undefined') {
      const ministate = {};

      _.forOwn(nextProps.value, (value, key) => {
        ministate[key] = value === null ? '' : value;
      });

      this.setState(ministate);
    }
  }

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
    this.props.onChange(nextState);
  };

  selectCountry = val => {
    const nextState = this.state;

    if (val === null) {
      nextState.country = null;
    } else {
      nextState.country = val.value;
    }

    this.setState(nextState);
    this.props.onChange(nextState);
  };

  render() {
    // const props = this.props
    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="street">
              Straße u. Hausnummer
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="street"
              value={this.state.street}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="extra_address_line">
              Addresszusatz
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="extra_address_line"
              value={this.state.extra_address_line}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="zip">
              PLZ / Ort
            </label>
          </div>
          <div className="col-xs-12 col-sm-2">
            <input
              name="zip"
              value={this.state.zip}
              onChange={e => this.handleChange(e)}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <input
              name="city"
              value={this.state.city}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="province">
              Bundesland / Land
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="province"
              value={this.state.province}
              onChange={e => this.handleChange(e)}
            />
          </div>
          <div className="col-xs-12 col-sm-4">
            <Select
              name="country"
              value={this.state.country}
              options={countriesOptions}
              onChange={country => this.selectCountry(country)}
              placeholder="Wählen Sie ein Land"
            />
          </div>
        </div>
      </div>
    );
  }
}
FormAddress.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
};
export default FormAddress;



// WEBPACK FOOTER //
// ./src/components/FormAddress/FormAddress.js